/**
 * PeerMate Avatar Utility
 * Provides resilience against internet disconnection by offering local fallback assets.
 */

// A high-fidelity, professional SVG avatar encoded as Base64 for zero-latency, offline reliability.
// This represents the "AI Expert" persona.
export const DEFAULT_AVATAR = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAwIiBoZWlnaHQ9IjgwMCIgdmlld0JveD0iMCAwIDgwMCA4MDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI4MDAiIGhlaWdodD0iODAwIiByeD0iNjQiIGZpbGw9IiMyNTYzRUIiLz4KPGNpcmNsZSBjeD0iNDAwIiBjeT0iMzIwIiByPSIxMjAiIGZpbGwtIndoaXRlIi8+CjxwYXRoIGQ9Ik0xNjAgNjQwaDQ4MGMwLTEzMi41NDgtMTA3LjQ1Mi0yNDAtMjQwLTI0MFMxNjAgNTA3LjQ1MiAxNjAgNjQwWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+`;

/**
 * Ensures an image URL is valid or returns the default fallback.
 * Can be used in src={getAvatarUrl(userAvatar)}
 */
export const getAvatarUrl = (url) => {
  if (!url || url.includes('dicebear.com')) {
    // If we're using DiceBear, we keep it but the component's onError will handle actual network failures.
    return url || DEFAULT_AVATAR;
  }
  return url;
};

/**
 * Common handler for img onError events.
 */
export const handleAvatarError = (e) => {
  e.target.src = DEFAULT_AVATAR;
  e.target.onerror = null; // Prevent infinite loops
};
